import { render, staticRenderFns } from "./manufacturerInfoDrawer.vue?vue&type=template&id=8ad55c1c&scoped=true"
import script from "./manufacturerInfoDrawer.vue?vue&type=script&lang=js"
export * from "./manufacturerInfoDrawer.vue?vue&type=script&lang=js"
import style0 from "./manufacturerInfoDrawer.vue?vue&type=style&index=0&id=8ad55c1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad55c1c",
  null
  
)

export default component.exports